/* eslint-disable import/prefer-default-export */
const FORM_ACTION = {
  EDIT: 'FORM_ACTION_EDIT',
  CREATE: 'FORM_ACTION_CREATE',
  DELETE: 'FORM_ACTION_DELETE',
  VIEW: 'FORM_ACTION_VIEW',
  LIST: 'FORM_ACTION_LIST',
};

export { FORM_ACTION };
